import { ParticipantTabLabelContainer } from "./ParticipantTabLabel";

export const ParticipantTabLabel = () => ParticipantTabLabelContainer();
